/**
 * Tracks whether this browser has already entered the interface.
 *
 * The landing page is for people who haven't been here yet — once someone has
 * entered, "/" should drop them back into the conversation rather than making
 * them click past a pitch every visit.
 *
 * Lives in its own module so App.tsx can read it on the root route without
 * eagerly pulling in the (lazy) landing page chunk.
 */
export const ENTERED_KEY = "memnora-entered";

export function hasEnteredInterface(): boolean {
  try {
    return localStorage.getItem(ENTERED_KEY) === "1";
  } catch {
    // Private mode / storage disabled — worst case they see the page again.
    return false;
  }
}

export function markEnteredInterface(): void {
  try {
    localStorage.setItem(ENTERED_KEY, "1");
  } catch {
    // Non-fatal: the landing page just shows again next visit.
  }
}

/** Called on sign-out so "/" shows the landing page again instead of staying parked on chat. */
export function clearEnteredInterface(): void {
  try {
    localStorage.removeItem(ENTERED_KEY);
  } catch {
    // Non-fatal.
  }
}
